var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(this.name))]),_vm._l((this.amts),function(amt){return _c('td',{key:amt,class:{
      achievement: true,
      won: _vm.earned >= amt
    }},[_vm._v(" amt: "+_vm._s(amt)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }